import PrimaryHint from '@components/atoms/buttons/PrimaryHint';
import { FormattedMessage } from '@utils/i18n';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import { useIntl } from 'react-intl';

dayjs.extend(AdvancedFormat);

const NextPayoutDateLabel = ({
    nextPayoutDate,
    isEligibleForDividend,
    onTooltipClick,
}: {
    nextPayoutDate?: Date;
    isEligibleForDividend?: boolean;
    onTooltipClick?: () => void;
}) => {
    const intl = useIntl();
    return isEligibleForDividend ? (
        <p className="Body-Medium semibold">
            {dayjs(nextPayoutDate).format(
                intl.formatMessage({ id: 'date_format_MMM_Do_YYYY' })
            )}
        </p>
    ) : (
        <p className="Body-Medium semibold">
            <PrimaryHint
                title={<FormattedMessage id="portfolio_next_payout_date" />}
                onClick={onTooltipClick}
                body={
                    <FormattedMessage
                        id="portfolio_next_payout_date_dialog_body"
                        defaultMessage="Your accrued and upcoming dividends will likely be below your payout threshold, so the next payment may be deferred and added to your balance due. You can update your payout threshold in Settings > Payment options."
                    />
                }
                icon="info"
            >
                {dayjs(nextPayoutDate).format(
                    intl.formatMessage({ id: 'date_format_MMM_Do_YYYY' })
                )}
            </PrimaryHint>
        </p>
    );
};

export default NextPayoutDateLabel;
